import { UploadOutlined } from "@ant-design/icons";
import { Button, Drawer, Input, message, Select, Upload } from "antd";
import { useEffect, useRef, useState } from "react";
import { fetchBranchMembers } from "../../../../apis/branch.api";
import EditClientForm from "../../../client/edit_client_form";
const { Option } = Select;

export interface BankDetails {
  bank_account_number: string;
  bank_ifsc: string;
  branch_upi: string;
}
export interface PFIEditOrderDetailsProps {
  client_data: any;
  setData: Function;
  setClientPricing: Function;
  setClientStudioDrawerOpen: Function;
  client_studio_drawer_open: boolean;
  branch_data: any;
  data: any;
  customer_po_file: File | null;
  setCustomerPoFile: Function;
  fetchBasicDetails: () => unknown;
}

const PFIEditOrderDetails = ({
  client_data,
  setData,
  setClientPricing,
  branch_data,
  data,
  setClientStudioDrawerOpen,
  client_studio_drawer_open,
  customer_po_file,
  setCustomerPoFile,
  fetchBasicDetails,
}: PFIEditOrderDetailsProps) => {
  // const [PIStatus, setPIStatus] = useState();
  const [members, setMembers] = useState<Array<any>>([]);
  const [, setPricing] = useState("public");
  const [, setVariantHandles] = useState<Array<any>>([]);
  const [openClientDrawer, setOpenClientDrawer] = useState(false);
  const isFirstRender = useRef(true);

  // useEffect(() => {
  //   if (data?.estimate_status !== PIStatus) {
  //     setData("estimate_status", PIStatus);
  //   }
  // }, [PIStatus]);

  useEffect(() => {
    fetchBranchMembers().then((res) => {
      const list: Array<any> = [];
      res?.map((member: any) => {
        list.push(member?.user);
      });
      setMembers(list);
    });
  }, []);

  useEffect(() => {
    let handles: Array<any> = [];
    data?.estimate_items?.map((item: any) => {
      if (item?.variant_handle) {
        handles.push(item.variant_handle);
      }
    });
    setVariantHandles(handles);
  }, [data]);

  useEffect(() => {
    if (client_data?.roles == 8) {
      setClientPricing("studio");
      setPricing("studio");
    } else {
      setClientPricing("public");
      setPricing("public");
    }
  }, [client_data]);

  return (
    <div className="p-3 py-2 row mb-2">
      <div className="th-font-size-16 th-font-weight-600 pb-3 primary-color-text">
        Order Details
      </div>
      <div className="col">
        <div className="row">
          <div className="col-4 th-font-weight-500">Created By</div>
          <div className="col-8 pb-1">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{data?.created_by}</div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Client </div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div>{client_data?.f_name}</div>
            </div>
          </div>
        </div>
        {/* <div className="row py-2">
          <div className="col-4 th-font-weight-500">Status</div>
          <div className="col-8">
            <div className="d-flex row">
              <div className="col-11">
                <Select
                  className="w-100"
                  key={"estimate_status"}
                  value={data?.estimate_status}
                  onChange={(e) => {
                    setPIStatus(e);
                  }}
                >
                  {statusOptions?.map((each, index) => (
                    <Option value={each?.value} key={each?.id}>
                      {each?.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Assign to</div>
          <div className="col-8">
            <div className="d-flex row">
              <div className="col-11">
                <Select
                  className="w-100"
                  key={"assin_to"}
                  value={data?.assigned_to}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={(e) => {
                    setData("assigned_to", e);
                  }}
                >
                  {members?.map((each, index) => (
                    <Option value={each?.id} key={each?.id}>
                      {each?.f_name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Customer PO No.</div>
          <div className="col-8">
            <div className="d-flex row">
              <div className="col-11">
                <Input
                  key={"customer_po"}
                  placeholder="Enter Customer PO Number"
                  value={data?.customer_po}
                  onChange={(e) => {
                    setData("customer_po", e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-4 th-font-weight-500">Customer PO File</div>
          <div className="col-8">
            <div className="d-flex row">
              <div className="col-11 d-flex align-items-center gap-2">
                <Upload
                  showUploadList={false}
                  accept=".pdf"
                  beforeUpload={(file) => {
                    if (file.type !== "application/pdf") {
                      message.error("Only PDF files are allowed.");
                      return false;
                    }
                    if (file.size > 5 * 1024 * 1024) {
                      message.error("File too large. Maximum size is 5MB.");
                      return false;
                    }
                    setCustomerPoFile(file);
                    return false;
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
                {customer_po_file ? (
                  <span>{customer_po_file.name} (will upload on save)</span>
                ) : (
                  data?.customer_po_link && (
                    <a
                      href={data?.customer_po_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View file
                    </a>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row py-2">
          <div className="col-4 th-font-weight-500">Bank Details</div>
          <div className="col-8">
            <div className="d-flex">
              <div className="pe-1">:</div>
              <div className="">
                <div>Account Number ({branch_data?.bank_account_number})</div>
                <div>IFSC Code ({branch_data?.bank_ifsc})</div>
                <div>UPI ({branch_data?.branch_upi})</div>
              </div>
            </div>
          </div>
        </div> */}
        <Drawer
          open={openClientDrawer}
          title="Edit client details"
          onClose={() => {
            setOpenClientDrawer(false);
            setClientStudioDrawerOpen(false);
          }}
        >
          <EditClientForm
            client={
              client_studio_drawer_open
                ? {
                    ...client_data,
                    role: 8,
                  }
                : {
                    ...client_data,
                  }
            }
            fetchBasicDetails={fetchBasicDetails}
            onClientEditDrawerClose={() => {
              setOpenClientDrawer(false);
            }}
          />
        </Drawer>
      </div>
    </div>
  );
};

export default PFIEditOrderDetails;
